import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_WATCH_LISTS } from '../types';
import { getWatchListsPending, getWatchListsFulfilled, getWatchListsRejected } from '../actions/getWatchListsActions';
import { sendApiRequest, notifyWarning, notifyError } from '../actions';
import generateError from '../utilities/generateError';
import { WATCHLIST_MESSAGES } from '../constants/watchListMessages';

const createPayload = payload => ({
  method: 'get',
  url: 'watchlist/get',
  onSuccess: [response => (response.data.length === 0 ? notifyWarning(WATCHLIST_MESSAGES.NOT_FOUND) : getWatchListsFulfilled(response))],
  onError: [
    getWatchListsRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getWatchListsEpic$ = action$ => action$.pipe(
  ofType(GET_WATCH_LISTS.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(getWatchListsPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default getWatchListsEpic$;


// WEBPACK FOOTER //
// ./src/epics/getWatchListsEpic.js